import { render, staticRenderFns } from "./ListTopLectures.vue?vue&type=template&id=681485c4&"
import script from "./ListTopLectures.vue?vue&type=script&lang=js&"
export * from "./ListTopLectures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports